// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"38b05545","352":"a382fac0"}[chunkId] + ".chunk.css";
};